// Main client
export { LegacyChainClient } from './core/LegacyChainClient';

// Export all types
export type {
  SDKConfig,
  SDKEvents,
  PlanType,
  ApiResponse,
  ApiError,
  RateLimitInfo,
  RateLimits,
  TimeCapsule,
  CapsuleMetadata,
  CreateCapsuleInput,
  PaymentCapsule,
  CreatePaymentInput,
  LegalDocument,
  SignerInfo,
  SelfDestructConfig,
  LegalMetadata,
  CreateLegalDocumentInput,
  PaginationParams,
  PaginatedResponse,
  CapsuleFilters,
  AnalyticsData,
  WebhookConfig,
  WebhookPayload,
  SpecializedCapsuleType,
  SpecializedCapsule,
  CreateFilmCapsuleInput,
  CreateCreatorMessageInput,
  CreateMysteryTraitInput,
  CreateVIPAccessInput,
  CreateArtProvenanceInput,
  CreateVotingCapsuleInput,
  CreateMusicCapsuleInput,
  CreateAchievementCapsuleInput,
  CreateEducationalCapsuleInput,
  CreateMemoryCapsuleInput,
  ZKMLCapsuleConfig,
  ZKMLCapsule,
  ZKMLVerificationRecord,
  ZKMLManifest,
  ZKMLInferenceResult
} from './types';

// Export services if needed directly
export { TimeCapsuleService } from './services/TimeCapsuleService';
export { PaymentService } from './services/PaymentService';
export { LegalDocumentService } from './services/LegalDocumentService';
export { AnalyticsService } from './services/AnalyticsService';
export { IPFSService } from './services/IPFSService';
export { WebhookService } from './services/WebhookService';
export { MultiSigService } from './services/MultiSigService';
export { SupportService } from './services/SupportService';
export { BrandingService } from './services/BrandingService';
export { SpecializedCapsuleService } from './services/SpecializedCapsuleService';
export { ZKMLService } from './services/ZKMLService';

// Export utilities
export { CryptoService } from './utils/crypto';
export { Logger } from './utils/logger';

// Export middleware
export { RateLimiter } from './middleware/rateLimiter';

// Version
export const VERSION = '1.1.2';

// Default export
export default LegacyChainClient; 